const DataDefActions = {
    START_LOAD: "data-def/start-load",
    LOADED: "data-def/loaded",
    LOAD_ERROR: "data-def/load-error",
};

export default DataDefActions;



// WEBPACK FOOTER //
// ./app/data/meta/DataDefActions.js